<template>
  <figure ref="figure" class="gallery-study-film">
    <ExpandableProjectMedia :title="title || label" :aspect-ratio="1920/1046" @change="onEnlarged">
    <div class="study-film-screen">
    <video ref="video" :poster="poster" :aria-label="title || label" muted playsinline loop preload="none" @play="playing = true" @pause="playing = false">
      <source v-if="loaded" :src="src" type="video/mp4">
      <track kind="captions" v-if="captions" :src="captions" srclang="en" label="English">
    </video>
    </div>
    <template #caption><figcaption>
      <span>{{ label }}</span>
      <div class="study-film-controls">
        <button v-if="sound" type="button" :aria-label="muted ? 'Turn sound on' : 'Mute demonstration'" :aria-pressed="!muted" @click="toggleSound">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 8h3l4-4v12l-4-4H3Z"/><path v-if="muted" d="m14 8 4 4m0-4-4 4"/><path v-else d="M13 7q4 3 0 6m3-9q6 6 0 12"/></svg>
        </button>
        <button type="button" :aria-label="playing ? 'Pause demonstration' : 'Play demonstration'" @click="toggle">
          <svg viewBox="0 0 16 16" aria-hidden="true"><path v-if="playing" d="M5 3v10m6-10v10"/><path v-else d="m5 3 8 5-8 5Z"/></svg>
        </button>
      </div>
    </figcaption></template>
    </ExpandableProjectMedia>
  </figure>
</template>
<script>
import ExpandableProjectMedia from './ExpandableProjectMedia.vue';
export default {
  components: {ExpandableProjectMedia},
  props: { src: String, poster: String, title: String, label: String, captions: String, sound: Boolean, active: { type: Boolean, default: true } },
  data: () => ({ loaded: false, playing: false, muted: true, userPaused: false, visible: false, enlarged:false }),
  watch: { active() { this.sync(); } },
  mounted() {
    this._visibility = () => this.sync();
    document.addEventListener('visibilitychange', this._visibility);
    this._observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.sync();
    }, { threshold: .35 });
    this._observer.observe(this.$refs.figure);
  },
  beforeUnmount() { this._observer?.disconnect(); document.removeEventListener('visibilitychange', this._visibility); this.$refs.video?.pause(); },
  methods: {
    onEnlarged(value) { this.enlarged=value;this.sync(); },
    async sync() {
      const video = this.$refs.video;
      if (!this.active || (!this.visible && !this.enlarged) || document.hidden || this.userPaused) { video.pause(); return; }
      if (!this.loaded) { this.loaded = true; await this.$nextTick(); video.load(); }
      if (!this.active || ((!this.visible && !this.enlarged) || document.hidden || this.userPaused)) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches || this._requestedPlay) video.play().catch(() => {});
    },
    toggle() { this.userPaused = this.playing; this._requestedPlay = !this.playing; this.sync(); },
    toggleSound() { this.muted = !this.muted; this.$refs.video.muted = this.muted; },
  },
};
</script>
<style scoped>
.gallery-study-film { margin: 0; position: relative; min-width: 0; }
.study-film-screen { position: relative; }
video { display: block; width: 100%; aspect-ratio: 1920/1046; object-fit: cover; background: #eeeae2; }
figcaption { display: flex; justify-content: space-between; align-items: center; gap: 1rem; min-height: 2.6rem; color: var(--site-text-secondary); font: 13px/1.4 'Quattrocento Sans', sans-serif; }
.study-film-controls { display: flex; gap: .25rem; }
button { display: grid; place-items: center; width: 36px; height: 36px; padding: 9px; border: 0; background: transparent; color: inherit; cursor: var(--site-interactive-cursor); opacity: .75; transition: opacity 180ms; }
button:hover { opacity: 1; }
button:focus-visible { outline: 1px solid currentColor; outline-offset: 1px; }
svg { width: 100%; height: 100%; fill: none; stroke: currentColor; stroke-width: 1.2; stroke-linecap: round; stroke-linejoin: round; }
@media(prefers-reduced-motion: reduce) { button { transition: none; } }
</style>
